import { AnimatePresence, motion } from "framer-motion"
import type { ReactNode } from "react"
import { fadeIn } from "@/shared/lib/motion"

interface CrossfadeProps {
	state: string
	children: ReactNode
	className?: string
}

export function Crossfade({ state, children, className }: CrossfadeProps) {
	return (
		<AnimatePresence mode="wait" initial={false}>
			<motion.div
				key={state}
				className={className}
				variants={fadeIn}
				initial="hidden"
				animate="visible"
				exit="exit"
			>
				{children}
			</motion.div>
		</AnimatePresence>
	)
}
